// ABOUTME: Service for GSEA (Gene Set Enrichment Analysis) API calls
// ABOUTME: Handles endpoint fetching, analysis submission, and result download

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  IGseaEndpointsResponse,
  IGseaAnalysisResponse,
} from '../interfaces/i-gsea';

@Injectable({
  providedIn: 'root',
})
export class GseaService {
  private baseUrl = environment.baseUrl + 'gsea';

  constructor(private http: HttpClient) {}

  /**
   * Get available endpoints for GSEA analysis
   */
  getEndpoints(): Observable<IGseaEndpointsResponse> {
    return this.http.get<IGseaEndpointsResponse>(`${this.baseUrl}/endpoints`);
  }

  /**
   * Run GSEA analysis with uploaded gene set file
   * Returns JSON with enrichment plots and result_id for download
   */
  analyze(endpoint: string, geneSetFile: File): Observable<IGseaAnalysisResponse> {
    const formData = new FormData();
    formData.append('endpoint', endpoint);
    formData.append('gene_sets_file', geneSetFile);

    return this.http
      .post<IGseaAnalysisResponse>(`${this.baseUrl}/analyze`, formData)
      .pipe(catchError(this.handleError));
  }

  /**
   * Download the full results ZIP for a completed analysis
   */
  downloadResults(resultId: string): Observable<Blob> {
    return this.http
      .get(`${this.baseUrl}/results/${resultId}/download`, {
        responseType: 'blob',
      })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    return throwError(() => error);
  }
}
